import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    adultActive: true,
    childActive: false,
    roomCount: 1,
    activeRoom: 1,
    rooms: [
        {
            id: 1,
            noOfAdults: 1,
            noOfChildren: 0,
            childrenAge: []
        }
    ]
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_HOTEL_ADULT: 
            let adultRooms = [...state.rooms];
            let adultRoom = {...adultRooms.filter((room) => {
                return action.id === room.id;
            })[0]}
            adultRoom.noOfAdults = parseInt(action.val, 10);
            adultRooms[action.id - 1] = adultRoom;
            return updateObject(state, {rooms: adultRooms});
        case actionTypes.SET_HOTEL_CHILD:
            let childRooms = [...state.rooms];
            let childRoom = {...childRooms.filter((room) => {
                return action.id === room.id;
            })[0]}
            if (childRoom.childrenAge.length === 0) {
                childRoom.noOfChildren = parseInt(action.val, 10);
                childRoom.childrenAge.length = parseInt(action.val, 10);
                for (let i = 0; i < action.val; i++) {
                    childRoom.childrenAge[i] = 0;
                }
                childRooms[action.id - 1] = childRoom;
            } else {
                childRoom.noOfChildren = parseInt(action.val, 10);
                for (let i = childRoom.childrenAge.length; i < action.val; i++) {
                    childRoom.childrenAge[i] = 0;
                }
                childRooms[action.id - 1] = childRoom;
            }
            return updateObject(state, {rooms: childRooms});
        case actionTypes.SET_CHILD_AGE:
            let updatedChildRooms = [...state.rooms];
            let updatedChildRoom = {...updatedChildRooms.filter((room) => {
                return action.roomIndex === room.id;
            })[0]}
            updatedChildRoom.childrenAge[parseInt(action.id, 10) - 1] = parseInt(action.val, 10);
            updatedChildRooms[action.roomIndex - 1] = updatedChildRoom;
            return updateObject(state, { rooms: updatedChildRooms });
        case actionTypes.CLICK_HOTEL_ADULT:
            return updateObject(state, {adultActive: true, childActive: false})
        case actionTypes.CLICK_HOTEL_CHILD:
            return updateObject(state, {adultActive: false, childActive: true})
        case actionTypes.ADD_HOTEL_ROOM:
            if (state.roomCount === 4) return state;
            let roomObject = {
                id: action.val + 1,
                noOfAdults: 1,
                noOfChildren: 0,
                childrenAge: []
            }
            let rooms = [...state.rooms];
            rooms.push(roomObject);
            return updateObject(state, { roomCount: action.val + 1, rooms: rooms, activeRoom: action.val + 1 })
        case actionTypes.REMOVE_HOTEL_ROOM:
            let removeRooms = [...state.rooms];
            for (let i = 0; i < removeRooms.length; i++) {
                if (removeRooms[i].id === action.val) {
                    removeRooms.splice(i, 1);
                }
            }
            let activeRoom = state.activeRoom;
            if (state.roomCount === 2) { activeRoom = 1; }
            return updateObject(state, { rooms: removeRooms, roomCount: action.val - 1, activeRoom: activeRoom });
        case actionTypes.SET_ACTIVE_ROOM:
            return updateObject(state, { activeRoom: action.val })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/hotelTravellers.js